import { cn } from '../lib/utils'
import { DialogContent } from './ui/dialog'

export default function ResponsiveDialogContent({
  style,
  className,
  elevateDom,
  cssString,
  ...props
}: React.ComponentProps<typeof DialogContent>) {
  return (
    <DialogContent
      {...props}
      elevateDom={elevateDom}
      cssString={cssString}
      onWheel={(e) => {
        e.stopPropagation()
        props.onWheel?.(e)
      }}
      onTouchMove={(e) => {
        e.stopPropagation()
        props.onTouchMove?.(e)
      }}
      className={cn(
        'animate-slideDown border-border sm:rounded-normal grid h-full max-w-full grid-rows-[auto_1fr_auto] gap-0 rounded-none p-0 sm:h-auto sm:max-h-[95vh] sm:max-w-[min(var(--content-max-width,850px),95vw)] sm:p-6 sm:border sm:bg-background sm:shadow-lg',
        className
      )}
      style={{
        animation: 'slideDownCustom 0.3s ease-in-out',
        ...style,
      }}
    />
  )
}
